var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import globalConstants from 'app/constants/global-constants';
import useCaseIcons from '../components/Icons/use-cases/index';
import { getUserFromStore } from '../helpers/userHelper';
var iconProps = {
    color: '#9599A1',
    size: 42,
    strokeWidth: 1,
};
var gSheet = {
    long_name: 'Spreadsheets Grapher',
    model_image: '//neo4jsandbox.com/img/blank.png',
    description: 'Load data directly from Google Spreadsheets',
    name: 'gsheets',
    logo: function (_a) {
        var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
        return (React.createElement(useCaseIcons.SpreadSheet, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
    },
};
export var getSandboxUseCases = function () {
    var cases = [];
    var user = getUserFromStore();
    if ((user && user.email && user.email.indexOf('@neotechnology.com') > -1) ||
        globalConstants.ENV !== 'prod') {
        cases.push(gSheet);
    }
    return cases.concat([
        {
            long_name: 'Twitter',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Load data directly from your twitter account',
            name: 'twitter-v2',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Twitter, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 4,
            graphLibrariesEnabled: ['GraphQL'],
            persona: 'developer',
        },
        {
            long_name: 'Movie Recommendations',
            model_image: '//neo4jsandbox.com/guides/recommendations/img/recommendations_datamodel.svg',
            description: 'Generate personalized real-time recommendations using a dataset of movie reviews.',
            name: 'recommendations',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.RecommendationIcon, __assign({ viewBox: undefined }, iconProps, { size: size || (iconProps && iconProps.size), color: color || iconProps.color })));
            },
            priority: 10,
            graphLibrariesEnabled: ['GraphQL', 'Graph Data Science'],
            persona: 'developer',
        },
        // {
        // 	long_name: 'Panama Papers by ICIJ',
        // 	model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
        // 	description: 'The Panama Papers dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
        // 	name: 'icij-panama-papers',
        // 	logo: ({ size = 36, color = '#fff' }) => <useCaseIcons.PanamaPapers {...iconProps} size={size || iconProps.size} color={color || iconProps.color} />,
        // 	priority: 1,
        // },
        {
            long_name: 'Crime Investigation',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Explore connections in crime data using the POLE - Person, Object, Location, Event - model in a public dataset from Manchester, U.K. ',
            name: 'pole',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.CrimeInvestigation, __assign({}, iconProps, { size: size || (iconProps && iconProps.size), color: color || iconProps.color })));
            },
            priority: 2,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'developer',
        },
        {
            long_name: 'Network and IT Management',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Dependency and root cause analysis + more for network and IT management',
            name: 'network-management',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Network, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 4,
            persona: 'developer',
        },
        {
            long_name: 'Blank Sandbox',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Blank Sandbox. Load your own data with LOAD CSV or create data from scratch.',
            name: 'blank-sandbox',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.BlankSandbox, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 4,
            persona: 'developer, data-scientist',
        },
        {
            long_name: 'Bloom Visual Discovery',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Neo4j Bloom is a graph exploration application for visually interacting with graph data.',
            name: 'bloom',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Bloom, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 6,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            long_name: 'Graph Data Science: Airport Routes',
            model_image: '//neo4jsandbox.com/img/graph-algorithms-meta.png',
            description: 'Leverage Neo4j Graph Data Science library to explore graph algorithms for analytics and feature engineering.',
            name: 'graph-data-science2',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.GraphAlgorithms, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 5,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            long_name: "Women's World Cup 2019",
            model_image: null,
            description: 'Explore the data behind the Women’s World Cup with our World Cup Graph.',
            name: 'wwc2019',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 42 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Football, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 7,
            persona: 'developer',
        },
        {
            long_name: 'Yelp Public Dataset',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: "Explore businesses, reviews, and users from Yelp's public dataset.",
            name: 'yelp',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Yelp, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 20,
            persona: 'developer',
        },
        {
            long_name: 'Fundamentals Training',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Neo4j Fundamentals classroom training with instructor-led guides',
            name: 'fundamentals',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.FundamentalTraining, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 21,
            persona: 'developer',
        },
        {
            long_name: 'Citations',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'This Sandbox is used for the course, Data Science with Neo4j. It contains Authors, Articles, and Venues that are connected by the AUTHOR, CITED, and VENUE relationships.',
            name: 'citations',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.BlankSandbox, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 22,
            persona: 'developer',
        },
        {
            model_image: '//neo4jsandbox.com/img/blank.png',
            name: 'twitch',
            description: 'Learn how to perform a network analysis by using Cypher and Graph Data Science algorithms',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Twitch, __assign({}, iconProps, { size: size || iconProps.size })));
            },
            priority: 23,
            long_name: 'Twitch',
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            model_image: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Stack_Overflow_icon.svg',
            name: 'stackoverflow',
            description: 'Stack Overflow questions, answers, tags, and comments and the relationships between them',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b;
                return (React.createElement(useCaseIcons.StackOverflow, __assign({}, iconProps, { size: size || iconProps.size })));
            },
            priority: 24,
            long_name: 'Stack Overflow',
            persona: 'developer',
            //	enabled: true
        },
        {
            long_name: 'Paradise Papers by ICIJ',
            model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
            description: 'The Paradise Papers dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
            name: 'icij-paradise-papers',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.PanamaPapers, __assign({ viewBox: undefined }, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 110,
            persona: 'developer',
        },
        // {
        // 	long_name: 'Legis-Graph',
        // 	model_image:
        // 		'//github.com/neo4j-contrib/sandbox-guides/raw/master/legis-graph/guide/img/lg_datamodel.png',
        // 	description:
        // 		'US Congress modeled as a Graph - bills, votes, members, and more.',
        // 	name: 'legis-graph',
        // 	logo: ({ size = 36, color = '#fff' }) => (
        // 		<useCaseIcons.LegisGraph
        // 			{...iconProps}
        // 			size={size || iconProps.size}
        // 			color={color || iconProps.color}
        // 		/>
        // 	),
        // 	priority: 101,
        // },
        {
            long_name: 'Russian Twitter Trolls',
            model_image: 'https://s3.amazonaws.com/neo4j-sandbox-www/img/twitter-trolls-datamodel.png',
            description: 'Explore data released by NBC News from their investigation into Russian Twitter Trolls around the 2016 US election.',
            name: 'twitter-trolls',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.RussianTroll, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 103,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            long_name: 'Fraud Detection',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Fraud detection with the Paysim financial dataset, Neo4j Graph Data Science, and Neo4j Bloom',
            name: 'fraud-detection',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.FraudDetection, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 100,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            long_name: 'Contact Tracing',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Explore contact tracing with Neo4j, Graph Data Science and Neo4j Bloom using a synthetic dataset of places, persons, and visits.',
            name: 'contact-tracing',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.ContactTracking, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 100,
            graphLibrariesEnabled: ['Graph Data Science'],
            persona: 'data-scientist',
        },
        {
            long_name: 'OpenStreetMap',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Identify points of interest and routing with Neo4j using this OpenStreetMap dataset of Central Park in New York City.',
            name: 'openstreetmap',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.OpenStreetMapIcon, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 1,
            graphLibrariesEnabled: ['GraphQL'],
            persona: 'developer',
        },
        {
            long_name: 'Movies',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'A Cypher guide to common graph query patterns involving connections between movies, actors, and directors.',
            name: 'movies',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.Movie, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 0,
            persona: 'developer',
        },
        {
            long_name: 'FinCEN Files',
            model_image: '//guides.neo4j.com/img/fincen-datamodel.png',
            description: 'The ICIJ FinCEN Files investigation explores money transfers around the globe.',
            name: 'fincen',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.CrimeInvestigation, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 100,
            persona: 'developer',
        },
        {
            long_name: 'Blank Sandbox - Graph Data Science',
            model_image: '//neo4jsandbox.com/img/graph-algorithms-meta.png',
            name: 'graph-data-science-blank-sandbox',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.GraphAlgorithms, __assign({}, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            description: 'Leverage Neo4j Graph Data Science library to explore graph algorithms for analytics and feature engineering.',
            priority: 90,
            persona: 'data-scientist',
        },
        {
            long_name: 'Offshore Leaks by ICIJ',
            model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
            description: 'The Offshore leaks dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
            name: 'icij-offshoreleaks',
            logo: function (_a) {
                var _b = _a.size, size = _b === void 0 ? 36 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c;
                return (React.createElement(useCaseIcons.PanamaPapers, __assign({ viewBox: undefined }, iconProps, { size: size || iconProps.size, color: color || iconProps.color })));
            },
            priority: 100,
            persona: 'developer',
        },
        // entity-resolution
        {
            long_name: 'Entity Resolution',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Entity Resolution, Record Linkage and Similarity wise recommendation with Neo4j',
            name: 'entity-resolution',
            logo: function () { return React.createElement(useCaseIcons.EntityResolution, null); },
            priority: 100,
            persona: 'developer',
        },
        // cybersecurity
        {
            long_name: 'Cybersecurity',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Cybersecurity, Active Directory environment auditing and analysis of possible attack paths using graph.',
            name: 'cybersecurity',
            logo: function () { return React.createElement(useCaseIcons.Cybersecurity, null); },
            priority: 100,
            persona: 'developer',
        },
        // healthcare-analytics
        {
            long_name: 'Healthcare Analytics',
            model_image: '//neo4jsandbox.com/img/blank.png',
            description: 'Load and analyze FDA Adverse Event Reporting System (FAERS) data with Neo4j',
            name: 'healthcare-analytics',
            logo: function () { return React.createElement(useCaseIcons.HealthcareAnalytics, null); },
            priority: 100,
            persona: 'developer',
        },
    ]);
};
export var sandboxUseCasesFlat = [
    {
        name: 'graph-data-science2',
        long_name: 'Graph Data Science',
        description: 'Explore graph algorithms for analytics and feature engineering.',
    },
    {
        name: 'entity-resolution',
        long_name: 'Entity Resolution',
        description: 'Entity Resolution, Record Linkage and Similarity wise recommendation with Neo4j',
    },
    {
        name: 'cybersecurity',
        long_name: 'Cybersecurity',
        description: 'Cybersecurity, Active Directory environment auditing and analysis of possible attack paths using graph.',
    },
    {
        name: 'healthcare-analytics',
        long_name: 'Healthcare Analytics',
        description: 'Load and analyze FDA Adverse Event Reporting System (FAERS) data with Neo4j',
    },
    {
        long_name: 'Recommendations',
        model_image: '//neo4jsandbox.com/guides/recommendations/img/recommendations_datamodel.svg',
        description: 'Generate personalized real-time recommendations using a dataset of movie reviews.',
        name: 'recommendations',
    },
    {
        model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
        name: 'ici-offshoreleaks',
        description: 'The Offshore leaks dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
        long_name: 'Offshore Leaks by ICIJ',
    },
    {
        model_image: '//neo4jsandbox.com/img/blank.png',
        name: 'twitch',
        description: 'Learn how to perform a network analysis by using Cypher and Graph Data Science algorithms',
        long_name: 'Twitch',
    },
    {
        model_image: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Stack_Overflow_icon.svg',
        name: 'stackoverflow',
        description: 'Stack Overflow questions, answers, tags, and comments and the relationships between them',
        long_name: 'Stack Overflow',
    },
    {
        long_name: 'Crime Investigation',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Explore connections in crime data using the POLE - Person, Object, Location, Event - model in a public dataset from Manchester, U.K. ',
        name: 'pole',
    },
    {
        long_name: "Women's World Cup 2019",
        model_image: null,
        description: 'Explore the data behind the Women’s World Cup with our World Cup Graph.',
        name: 'wwc2019',
    },
    {
        long_name: 'Network and IT Management',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Dependency and root cause analysis + more for network and IT management',
        name: 'network-management',
    },
    {
        long_name: 'Twitter',
        model_image: '//neo4jsandbox.com/guides/twitter/img/twitter-data-model.svg',
        description: 'Graph your Twitter network!  This Sandbox will show you your tweets, mentions and more.',
        name: 'twitter-v2',
    },
    {
        long_name: 'Spreadsheets Grapher',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Load data directly from Google Spreadsheets',
        name: 'gsheets',
    },
    {
        long_name: 'Russian Twitter Trolls',
        model_image: 'https://s3.amazonaws.com/neo4j-sandbox-www/img/twitter-trolls-datamodel.png',
        description: 'Explore data released by NBC News from their investigation into Russian Twitter Trolls around the 2016 US election.',
        name: 'twitter-trolls',
    },
    {
        long_name: 'Trumpworld',
        model_image: '//neo4jsandbox.com/img/trumpworld_datamodel.png',
        description: 'Explore connections in and around the Trump Administration using this dataset from BuzzFeed.',
        name: 'trumpworld',
    },
    {
        long_name: 'Bloom Visual Discovery',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Neo4j Bloom is a graph exploration application for visually interacting with graph data.',
        name: 'bloom',
    },
    {
        long_name: 'Graph Data Science',
        model_image: '//neo4jsandbox.com/img/graph-algorithms-meta.png',
        description: 'Leverage Neo4j Graph Data Science library to explore graph algorithms for analytics and feature engineering.',
        name: 'graph-data-science2',
    },
    {
        long_name: 'Paradise Papers by ICIJ',
        model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
        description: 'The Paradise Papers dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
        name: 'icij-paradise-papers',
    },
    {
        long_name: 'Blank Sandbox',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Blank Sandbox. Load your own data with LOAD CSV or create data from scratch.',
        name: 'blank-sandbox',
    },
    // {
    // 	long_name: 'Legis-Graph',
    // 	model_image:
    // 		'//github.com/neo4j-contrib/sandbox-guides/raw/master/legis-graph/guide/img/lg_datamodel.png',
    // 	description:
    // 		'US Congress modeled as a Graph - bills, votes, members, and more.',
    // 	name: 'legis-graph',
    // },
    {
        long_name: 'Panama Papers by ICIJ',
        model_image: 'https://cloudfront-files-1.publicintegrity.org/offshoreleaks/neo4j/guide/img/datamodel.png',
        description: 'The Panama Papers dataset and guide from the International Consortium of Investigative Journalists (ICIJ).',
        name: 'icij-panama-papers',
    },
    {
        long_name: 'Neo4j 3.4',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Neo4j 3.4, including a guide demonstrating the new spatial functionality and date/time support',
        name: 'blank-sandbox-3_4',
    },
    {
        long_name: 'Neo4j 3.3',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Neo4j 3.3 release - Blank Sandbox',
        name: 'blank-sandbox-3_3',
    },
    {
        long_name: 'GraphConnect 2018 Schedule',
        model_image: null,
        description: 'GraphConnect 2018 schedule graph',
        name: 'gc-nyc-2018',
    },
    {
        long_name: 'Neo4j 3.5.3',
        model_image: '//neo4jsandbox.com/img/blank.png',
        description: 'Neo4j 3.5 release - Blank Sandbox',
        name: 'blank-sandbox-3_5',
    },
    {
        long_name: 'Fraud Detection',
        name: 'fraud-detection',
    },
    {
        long_name: 'Contact Tracing',
        name: 'contact-tracing',
    },
    {
        long_name: 'OpenStreetMap',
        name: 'openstreetmap',
    },
    {
        long_name: 'ICIJ FinCEN Files Investigation Dataset',
        name: 'fincen',
    },
    {
        long_name: 'Movies',
        name: 'movies',
    },
    {
        long_name: 'Blank Sandbox - Graph Data Science',
        name: 'graph-data-science-blank-sandbox',
    },
];
